// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Production40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Production40: FC<Production40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path
                d="M17.573 34.167h4.854l.346-2.741a3.333 3.333 0 0 1 1.63-2.461l.534-.311.061-.035.705-.392c.899-.5 1.981-.562 2.932-.163l2.564 1.075 2.4-4.101-2.218-1.662a3.329 3.329 0 0 1-1.334-2.664v-.305c0-.182 0-.516.027-1.236a3.325 3.325 0 0 1 1.331-2.533l2.236-1.676-2.403-4.107-2.622 1.09a3.345 3.345 0 0 1-2.88-.146c-.229-.125-.578-.317-.835-.475a20.684 20.684 0 0 0-.478-.283 3.344 3.344 0 0 1-1.65-2.475l-.346-2.733h-4.854l-.347 2.744a3.336 3.336 0 0 1-1.609 2.45c-.208.122-.287.17-.336.2l-.03.017c-.065.04-.112.066-.257.15l-.028.017c-.261.15-.476.267-.711.393a3.358 3.358 0 0 1-2.874.14l-2.62-1.09-2.402 4.108 2.218 1.662a3.329 3.329 0 0 1 1.334 2.664v1.424a3.33 3.33 0 0 1-1.334 2.664l-2.218 1.662 2.403 4.107 2.602-1.082a3.358 3.358 0 0 1 2.974.196l.563.327.64.357a3.334 3.334 0 0 1 1.687 2.493l.345 2.73Zm-2.297 1.77c.053.416.413.73.84.73h7.768a.842.842 0 0 0 .84-.73l.53-4.198a.832.832 0 0 1 .409-.614l.533-.31.016-.01.707-.394a.86.86 0 0 1 .75-.042l3.892 1.633a.853.853 0 0 0 1.065-.35l3.886-6.642a.825.825 0 0 0-.221-1.079l-3.41-2.556a.83.83 0 0 1-.334-.663v-.305c0-.154 0-.455.026-1.141a.825.825 0 0 1 .332-.628l3.428-2.57a.825.825 0 0 0 .22-1.078l-3.886-6.643a.853.853 0 0 0-1.062-.352l-3.95 1.642a.845.845 0 0 1-.726-.035 17.438 17.438 0 0 1-.718-.407c-.164-.101-.367-.22-.54-.32a.844.844 0 0 1-.418-.623l-.53-4.188a.842.842 0 0 0-.84-.73h-7.767a.842.842 0 0 0-.84.73l-.53 4.2a.835.835 0 0 1-.405.612l-.347.207c-.07.043-.07.043-.278.163-.228.13-.416.233-.641.354a.858.858 0 0 1-.734.035l-3.946-1.64a.853.853 0 0 0-1.062.352L3.446 14.99a.825.825 0 0 0 .221 1.079l3.41 2.556a.83.83 0 0 1 .334.663v1.424c0 .26-.123.505-.333.663l-3.41 2.556a.825.825 0 0 0-.222 1.08l3.887 6.642a.853.853 0 0 0 1.062.352l3.929-1.634a.858.858 0 0 1 .759.05l.575.334.013.008.653.363c.233.13.39.361.424.623l.528 4.187Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
            <path
                d="M20 23.333a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666Zm0 2.5a5.833 5.833 0 1 0 0-11.666 5.833 5.833 0 0 0 0 11.666Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Production40;
